(function () {
  if (window.__sizeChartLoaderInit) return;
  window.__sizeChartLoaderInit = true;

  function loadInto(container) {
    if (!container || container.dataset.loaded === 'true') return;

    var url = container.getAttribute('data-size-chart-url');
    if (!url) return;

    // If the page's rich-text body already filled the modal, leave it alone.
    if (container.textContent.trim() !== '' || container.children.length > 0) {
      container.dataset.loaded = 'true';
      return;
    }

    container.dataset.loaded = 'true';

    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        // Grab only the size guide section (by its schema class) so the page's
        // header and footer are never pulled into the modal. Fall back to the
        // main content element if the section can't be found.
        var source =
          doc.querySelector('.shopify-section--size-guide') ||
          doc.querySelector('#main-content') ||
          doc.querySelector('#MainContent') ||
          doc.querySelector('main');
        if (!source) return;

        container.innerHTML = source.outerHTML;

        // <script> tags inserted via innerHTML don't execute — recreate them so they run
        // (this is what lets the CM/INCHES toggle keep working inside the modal).
        container.querySelectorAll('script').forEach(function (oldScript) {
          var newScript = document.createElement('script');
          for (var i = 0; i < oldScript.attributes.length; i++) {
            newScript.setAttribute(oldScript.attributes[i].name, oldScript.attributes[i].value);
          }
          newScript.textContent = oldScript.textContent;
          oldScript.parentNode.replaceChild(newScript, oldScript);
        });
      })
      .catch(function () {
        // Allow another attempt on the next open if the fetch failed.
        container.dataset.loaded = 'false';
      });
  }

  // Capture phase so we still fire even if the modal trigger stops propagation.
  document.addEventListener('click', function (event) {
    var button = event.target.closest('button[aria-controls^="size-chart-"]');
    if (!button) return;

    var modal = document.getElementById(button.getAttribute('aria-controls'));
    if (!modal) return;

    loadInto(modal.querySelector('[data-size-chart-content]'));
  }, true);
})();
